import { PropsWithChildren } from 'react'
import { compose } from 'redux'

import { generateRoute } from 'utils/routing'

import { withRouter, withRouterProps } from 'services/router'

import { Page, PageTabNav, Section, Spinner } from 'components'

import i18n from 'translations'

interface ChildSessionsViewProps extends PropsWithChildren {
  isLoading: boolean
}

type ChildSessionsViewFullProps = ChildSessionsViewProps & withRouterProps

const ChildSessionsView = ({
  children,
  isLoading,
  params,
  router,
}: ChildSessionsViewFullProps) => {
  const { childId } = params

  const renderContent = () => {
    if (isLoading) {
      return <Spinner />
    }

    const sessionUrl = generateRoute('CHILDREN.CHILD.BOOKING_PATTERN.SESSIONS.VIEW', { childId })
    const sessionHistoryUrl = generateRoute('CHILDREN.CHILD.BOOKING_PATTERN.SESSIONS.VIEW.HISTORY', { childId })

    return (
      <Section title={i18n.t('module:Children:Child:BookingPattern:Sessions:title')}>
        <PageTabNav>
          <PageTabNav.Item
            isActive={router.isActive(sessionUrl, true)}
            label={i18n.t('module:Children:Child:BookingPattern:Sessions:List:Current:title')}
            to={sessionUrl}
          />
          <PageTabNav.Item
            isActive={router.isActive(sessionHistoryUrl, true)}
            label={i18n.t('module:Children:Child:BookingPattern:Sessions:List:sessionHistory')}
            to={sessionHistoryUrl}
          />
        </PageTabNav>
        {children}
      </Section>
    )
  }

  return (
    <Page isFetching={isLoading}>
      <Page.Content>
        {renderContent()}
      </Page.Content>
    </Page>
  )
}

const enhance = compose(
  withRouter,
)

export default enhance(ChildSessionsView)
